import {RESULT_PAGE} from './utils.js'

export const DETAILS_TITLE_GAV_KURZ_I18N_KEY = 'mindestlohnrechner.details.title.gavKurz'

const PAGE_TITLE_KEYS = {
  [RESULT_PAGE.NO_MATCH]: 'mindestlohnrechner.details.title.noMatch',
  [RESULT_PAGE.GAV_KURZ]: DETAILS_TITLE_GAV_KURZ_I18N_KEY,
  [RESULT_PAGE.KONTAKTE]: 'mindestlohnrechner.details.title.kontakte',
  default: 'mindestlohnrechner.details.title.mindestloehne'
}

export function getResultPageTitleKey(page) {
  return PAGE_TITLE_KEYS[page] || PAGE_TITLE_KEYS.default
}

export function formatResultPageTitle(page, translate, contractName) {
  const prefix = translate(getResultPageTitleKey(page))
  if (page === RESULT_PAGE.NO_MATCH || !contractName) {
    return prefix
  }
  return `${prefix} ${contractName}`
}
